module.exports = __webpack_public_path__ + "static/img/04.cd84bc8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about/04.png
// module id = +8Ce
// module chunks = 1